(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name RegistroController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('RegistroController', RegistroController);

    RegistroController.$inject = ["GenerallabService","UserService","$timeout","$location",'$anchorScroll'];


    function RegistroController(GenerallabService,UserService,$timeout,$location,$anchorScroll)
    {

    	var vm = this;
        vm.code = 0;
    	vm.msg = "";
        vm.loadingRec = false;
        vm.newPass = {pass1:"",pass2:"",hash:""};
        vm.msgRec = "";

        vm.loading = false;
        vm.recuperarDatos = {};
        vm.generalLab = GenerallabService;

    	vm.registro = { centro : { veterinarios : [{nombre:"",email:""}]} };
    	vm.registrarse = function(form){
            //console.log(form.reg_account_fiscal);
            
            //return false;
            if (!form.$valid) {
                angular.element("[name='" + form.$name + "']").find('.ng-invalid:visible:first').focus();
                return false;
            }
            vm.loading = true;
    		UserService.registrarUsuario(vm.registro,function(data){
                vm.code = data.code;
    			vm.msg = data.msg;
                if(data.code==-10){
                    angular.element("[name='" + form.$name + "']").find('#reg_email').focus();
                }
                if(data.code==10){
                    fbq('track', 'CompleteRegistration');
                    location.reload();
                }else{
                    vm.loading = false;
                }
            });
    	}

        

    	vm.addDoctor = function(){
    		vm.registro.centro.veterinarios.push({nombre:"",email:""});
    	}

        vm.borrarDoctor = function(index){
            vm.registro.centro.veterinarios.splice(index,1);
        }

        vm.ibanEspacios = function(){
            //console.log("E");
            vm.registro.reg_account_fiscal = vm.registro.reg_account_fiscal.split(' ').join('');
        }
        
        /*vm.generalLab.optionsProvincias.initSelection = function (element, callback) {
            callback({id: '2', text: '3' });
        };*/
        
        vm.copiarFiscales = function(){
            vm.registro.centro.reg_center = vm.registro.reg_company;
            vm.registro.centro.reg_address = vm.registro.reg_address_fiscal;//vm.registro.reg_zip_fiscal;
            vm.registro.centro.reg_zip = vm.registro.reg_zip_fiscal;//vm.registro.reg_city_fiscal;
            vm.registro.centro.reg_city = vm.registro.reg_city_fiscal;//vm.registro.reg_province_fiscal;
            $timeout(function(){
                if(typeof(vm.registro.reg_province_fiscal)!='undefined' && vm.registro.reg_province_fiscal!=''){
                    $('#reg_province').select2("trigger", "select", {
                        data: { id: vm.registro.reg_province_fiscal, text:$('#reg_province_fiscal option:selected').text() }
                    });
                    vm.registro.centro.reg_province = vm.registro.reg_province_fiscal;
                }

                if(typeof(vm.registro.reg_city_fiscal)!='undefined' && vm.registro.reg_city_fiscal!=''){
                    $('#reg_city').select2("trigger", "select", {
                        data: { id: vm.registro.reg_city_fiscal, text:$('#reg_city_fiscal option:selected').text() }
                    });
                    vm.registro.centro.reg_city = vm.registro.reg_city_fiscal;
                }
                
            });
        }

        vm.copiarClinica = function(){
            vm.registro.centro.nombre_fiscal = vm.registro.centro.reg_center;
            vm.registro.centro.direccion_fiscal = vm.registro.centro.reg_address;
            vm.registro.centro.cp_fiscal = vm.registro.centro.reg_zip;
            vm.registro.centro.poblacion_fiscal = vm.registro.centro.reg_city;
              $timeout(function(){
                if(typeof(vm.registro.centro.reg_province)!='undefined' && vm.registro.centro.reg_province!=''){
                    $('#provincia_fiscal').select2("trigger", "select", {
                        data: { id: vm.registro.centro.reg_province, text:$('#reg_province option:selected').text() }
                    });
                    vm.registro.centro.provincia_fiscal = vm.registro.centro.reg_province;
                }
            });
        }

        vm.recuperarPass = function(){
            vm.loadingRec = true;
            UserService.recuperarPass(vm.recuperarDatos,function(data){
                if(data.code==1){
                    vm.recuperarDatos.mail = "";
                }
                vm.msgRec = data.msg;
                vm.loadingRec = false;
            });
        }

        vm.recuperarPassByEmail = function(email){
            vm.loadingRec = true;
            vm.recuperarDatos.mail = email;
            UserService.recuperarPass(vm.recuperarDatos,function(data){
                if(data.code==1){
                    vm.recuperarDatos.mail = "";
                }
                vm.msgRec = data.msg;
                vm.loadingRec = false;
            });
        }
               
    }


})();